export default __webpack_public_path__ + "static/media/history_960_ko.e2795544.svg";